<mat-card class="mat-elevation-z0" style="height:300px; width: 500px;">
  <mat-card-content>

    <div style="font-family: 'Century Gothic', sans-serif; font-weight: 700; font-size: 15px; margin-bottom: 20px;">
      Πρόσθετη επαλήθευση ασφαλείας
    </div>


    <mat-horizontal-stepper [linear]="isLinear" #stepper fxHide.lt-md fxShow.gt-sm>
      <mat-step [stepControl]="firstFormGroup" *ngIf="steps === 3">
        <form [formGroup]="firstFormGroup">
          <ng-template matStepLabel style="font-family: 'Century Gothic', sans-serif">{{step1Title}}</ng-template>
          <div fxLayout="column" style="font-family: 'Century Gothic', sans-serif; margin-top:30px;">
          <div fxLayout="row">
            Επιλέξτε που θέλετε να λάβετε τον κωδικό ασφαλείας
          </div>

            <div fxLayout="row" style=" word-break: break-word; font-family: 'Century Gothic', sans-serif; width:300px;">
              <mat-radio-group class="radioGroup" formControlName="firstCtrl"  [(ngModel)]="radioSelection">
                <div fxLayout="column">
                  <div fxLayout="row" style="width:300px !important;">
                    <mat-radio-button class="radioRow" (change)="setValue(1)" value="1"><span>Ασποστολή SMS στο κινητό που έχετε δηλώσει ({{maskedPhone}})</span></mat-radio-button>
                  </div>
                  <div fxLayout="row" style="width:300px !important;">

                    <mat-radio-button class="radioRow" (change)="setValue(2)" value="2"><span>Ασποστολή Email στο email που έχετε δηλώσει ({{maskedEmail}})</span></mat-radio-button>
                  </div>
                </div>

              </mat-radio-group>
            </div>


          </div>

        </form>
      </mat-step>
      <mat-step [stepControl]="secondFormGroup">
        <form [formGroup]="secondFormGroup">
          <ng-template matStepLabel style="font-family: 'Century Gothic', sans-serif">{{step2Title}}</ng-template>

          <div fxLayout="column" fxLayoutAlign="center center" style="margin-top:20px;">
            <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif; font-size: 20px;">Εισάγετε τον κωδικό</div>
            <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif; font-size: 12px; margin-top:20px; white-space: normal; width:350px;">{{authStepMessage}}</div>
            <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif; margin-top:20px;">

              <mat-form-field>
                <label>
                  <input matInput formControlName="secondCtrl" [(ngModel)]="secretCode" maxlength="6" minlength="6" required placeholder="Κωδικός">
                </label>
              </mat-form-field>

            </div>
          </div>
        </form>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel style="font-family: 'Century Gothic', sans-serif">{{step3Title}}</ng-template>


        <div fxLayout="column" fxLayoutAlign="center center" style="margin-top:40px;">
          <div fxLayout="row">
            <img src="assets/images/complete-icon.png" alt="complete" style="width:50px; height:50px;" />
          </div>
          <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif; margin-top:20px;">Η αυθεντικοποίησή σας ολοκληρώθηκε με επιτυχία</div>
          <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif; margin-top:10px;">
            <button style="font-family: 'Century Gothic', sans-serif;" mat-flat-button color="primary" (click)="closeDialog()">Κλείσιμο</button>
          </div>
        </div>
      </mat-step>
    </mat-horizontal-stepper>

    <mat-vertical-stepper [linear]="isLinear" #stepper fxShow.lt-md fxHide.gt-sm>
      <mat-step [stepControl]="firstFormGroup" *ngIf="steps === 3">
        <form [formGroup]="firstFormGroup">
          <ng-template matStepLabel style="font-family: 'Century Gothic', sans-serif">{{step1Title}}</ng-template>
          <div fxLayout="column" style="font-family: 'Century Gothic', sans-serif; margin-top:30px;">
            <div fxLayout="row">
              Επιλέξτε που θέλετε να λάβετε τον κωδικό ασφαλείας
            </div>

            <div fxLayout="row" style=" word-break: break-word; font-family: 'Century Gothic', sans-serif; width:300px;">
              <mat-radio-group class="radioGroup" formControlName="firstCtrl"  [(ngModel)]="radioSelection">
                <div fxLayout="column">
                  <div fxLayout="row" style="width:300px !important;">
                    <mat-radio-button class="radioRow" (change)="setValue(1)" value="1"><span>Ασποστολή SMS στο κινητό που έχετε δηλώσει ({{maskedPhone}})</span></mat-radio-button>
                  </div>
                  <div fxLayout="row" style="width:300px !important;">

                    <mat-radio-button class="radioRow" (change)="setValue(2)" value="2"><span>Ασποστολή Email στο email που έχετε δηλώσει ({{maskedEmail}})</span></mat-radio-button>
                  </div>
                </div>

              </mat-radio-group>
            </div>


          </div>

        </form>
      </mat-step>
      <mat-step [stepControl]="secondFormGroup">
        <form [formGroup]="secondFormGroup">
          <ng-template matStepLabel style="font-family: 'Century Gothic', sans-serif">{{step2Title}}</ng-template>

          <div fxLayout="column" fxLayoutAlign="center center" style="margin-top:20px;">
            <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif; font-size: 20px;">Εισάγετε τον κωδικό</div>
            <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif; font-size: 12px; margin-top:20px; white-space: normal; width:350px;">{{authStepMessage}}</div>
            <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif; margin-top:20px;">

              <mat-form-field>
                <label>
                  <input matInput formControlName="secondCtrl" [(ngModel)]="secretCode" maxlength="6" minlength="6" required placeholder="Κωδικός">
                </label>
              </mat-form-field>

            </div>
          </div>
        </form>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel style="font-family: 'Century Gothic', sans-serif">{{step3Title}}</ng-template>


        <div fxLayout="column" fxLayoutAlign="center center" style="margin-top:40px;">
          <div fxLayout="row">
            <img src="assets/images/complete-icon.png" alt="complete" style="width:50px; height:50px;" />
          </div>
          <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif; margin-top:20px;">Η αυθεντικοποίησή σας ολοκληρώθηκε με επιτυχία</div>
          <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif; margin-top:10px;">
            <button style="font-family: 'Century Gothic', sans-serif;" mat-flat-button color="primary" (click)="closeDialog()">Κλείσιμο</button>
          </div>
        </div>
      </mat-step>
    </mat-vertical-stepper>


  </mat-card-content>

  <mat-card-actions>
    <ng-container *ngIf="steps === 2 then StraightAuth else UpdateProvidersFirst"></ng-container>

    <ng-template #StraightAuth>
      <div fxLayout="row" fxFlex="100" fxLayoutAlign="end center">
        <div *ngIf="stepper.selectedIndex === 0">
          <button mat-flat-button color="primary" [disabled]="validCode()" (click)="next()" [class.spinner]="secondStepLoading">Επομένο</button>
        </div>
      </div>

    </ng-template>

    <ng-template #UpdateProvidersFirst>
      <div fxLayout="row" fxFlex="100" fxLayoutAlign="end center">
        <div *ngIf="stepper.selectedIndex === 0">
          <button mat-flat-button color="primary" [disabled]="proceedStep() && !firstStepLoading" (click)="next()" [class.spinner]="firstStepLoading">Επομένο</button>
        </div>

        <div fxLayout="row" *ngIf="stepper.selectedIndex === 1" fxLayoutGap="10px">
          <button mat-flat-button color="primary" (click)="previous()">Προηγούμενο</button>
          <button mat-flat-button color="primary" [disabled]="validCode()" (click)="next()" [class.spinner]="secondStepLoading">Επομένο</button>
        </div>
      </div>
    </ng-template>

  </mat-card-actions>
</mat-card>
